const MuiBreadcrumbs = {
    styleOverrides: {
        separator: ({ theme })=>({
                margin: theme.spacing(0, 0.5)
            })
    }
};
export { MuiBreadcrumbs };

//# sourceMappingURL=breadcrumb-overrides.js.map